import { pick, values } from 'lodash'
import { Collapsible } from 'radix-ui'
import { useMemo } from 'react'

import useToggleState from '@/legacy-src/hooks/useToggleState'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'

import { RecommendedTherapistProfileBioSessionRolldownUI } from './RecommendedTherapistProfileBioSessionRolldown.ui'

export interface RecommendedTherapistProfileBioSessionRolldownProps {
  office: NonNullable<TherapistType['office']>
}

export const RecommendedTherapistProfileBioSessionRolldown = ({
  office,
}: RecommendedTherapistProfileBioSessionRolldownProps) => {
  const [open, toggle] = useToggleState()

  const isEmpty = useMemo(() => {
    const amenities = pick(office, ['freeParking', 'paidParkingNearby', 'waitingAreaAvailable', 'wheelchairAccessible'])
    return values(amenities).every((value) => !value)
  }, [office])

  if (isEmpty) {
    return null
  }

  return (
    <Collapsible.Root open={open} onOpenChange={toggle}>
      <RecommendedTherapistProfileBioSessionRolldownUI open={open} office={office} />
    </Collapsible.Root>
  )
}
